import { Component } from '@angular/core';
import {RouterLink} from "@angular/router";

@Component({
  selector: 'app-uc-advance',
  standalone: true,
    imports: [
        RouterLink
    ],
  templateUrl: './uc-advance.component.html',
  styleUrl: './uc-advance.component.scss'
})
export class UcAdvanceComponent {

}
